<ohp-dropdown-menu *ngIf="dropdownMenuModel?.items?.length || actionContextMenuEnabled"
                   [menuModel]="dropdownMenuModel"
                   [mobileContextMenu]="mobileMenusEnabled"
                   [leftAlignedCard]="leftAlignedCard"
                   [hideContent]="actionContextMenuEnabled"
                   (toggleMenu)="onToggleMenu($event)"
                   (selectItem)="onSelectItem($event)"
                   (focusLink)="onFocusLink($event)">
    <div ohpMenuLinkContent>
        <ohp-icon-font iconFontName="Ellipsis"
                       size="16"
                       [cssClass]="(iconClass ? (iconClass + ' ') : '') + (fluentRefresh ? ('actions-menu__icon--fluent' + (isOpen ? ' ms-fcl-tp' : '')) : 'actions-menu__icon ms-fcl-ns ms-fcl-nd-h ms-fcl-nd-f')"
                       [ariaVisible]="true">
        </ohp-icon-font>
    </div>
    <div *ohpDropdownMenuItemContent="let item = item; let index = index" class="actions-menu-item__flex-content" role="menuitem">
        <ohp-icon-font [iconFontType]="item.icon"
                       [iconFontCssClass]="item.iconCssClass"
                       size="16"
                       [color]="item.iconColor"
                       cssClass="actions-menu-item__icon ms-fcl-bl {{ item.disabled ? ' menu-item__icon--disabled' : ''}}">
        </ohp-icon-font>
        <div class="list-item__title menu-item__title ms-fcl-bl" [ngClass]="{'menu-item__title--disabled': item.disabled}">{{ item.title }}</div>
    </div>
</ohp-dropdown-menu>
